/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState, useEffect } from "react";
import "./mainnav.css";
import { CSSTransition } from "react-transition-group";
import Menu from "@material-ui/icons/Menu";
import { logoutClaveUnica } from "../commons/api"
import Countdown from 'react-countdown';
import ReactGA from 'react-ga';


export default function Header(props) {
  const [isNavVisible, setNavVisibility] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 700px)");
    mediaQuery.addListener(handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery);

    return () => {
      mediaQuery.removeListener(handleMediaQueryChange);
    };
  }, []);

  const handleMediaQueryChange = mediaQuery => {
    if (mediaQuery.matches) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const toggleNav = () => {
    setNavVisibility(!isNavVisible);
  };

  const handleClick = async (e) => {
    e.preventDefault();
      logoutClaveUnica()
  
  }

  const renderer =  ({ formatted: { hours, minutes, seconds }, completed }) => {
    if (completed) {
      // Render a completed state
      logoutClaveUnica()
      //return <Completionist />;
    } else {
      // Render a countdown
      //return <span>{hours}:{minutes}:{seconds}</span>;
      return <span>{minutes}:{seconds}</span>;
    }
  };

  useEffect(() => {
    ReactGA.initialize('G-70TWKDMVZX');
  }, []);
  

  //const {user} = props
  //console.log("linea61Nat:",user)
  /*
  ReactGA.event({
    category: 'inicio',
    action: 'inicio_formulario',
    label: 'inicio',
  })
*/

  return (
    <header className="Header">
      <div>
        <h3 style={{ marginTop: 14, fontFamily: 'inherit' }}>{props.titulo}</h3>
      </div>
      <CSSTransition
        in={!isSmallScreen || isNavVisible}
        timeout={350}
        classNames="NavAnimation"
        unmountOnExit
      >
        <nav className="Nav">
        
          <div>
            <p style={{ fontSize: 14, textAlign: "left", margin: "2px", color: 'white' }} >Tu sesión finaliza en <Countdown date={Date.now() + 900000} renderer={renderer}/> </p>
            <div onClick={handleClick} style={{ backgroundColor: 'orange', color: 'white', cursor: 'pointer', borderRadius: 5 }} variant="contained" >Cerrar Sesión</div>
          </div>

        </nav>
      </CSSTransition>
      <button onClick={toggleNav} className="Burger" style={{ color: 'white'  }}>
        <Menu />
      </button>
    </header>
  );
}